import React from "react";
import SampleWidget from "../../dashboard/widgets/GeneralInfo/SampleWidget";
import { ModuleListContainer } from "./EmployeePageWidgets.styles";

interface ModuleListWidgetProps<T> {
  title: string;
  items?: T[] | null;
  loading?: boolean;
  emptyLabel?: string;
  renderItem: (item: T, index: number) => React.ReactNode;
  onRefresh?: () => void;
}

function ModuleListWidget<T>({
  title,
  items,
  loading = false,
  emptyLabel,
  renderItem,
  onRefresh,
}: ModuleListWidgetProps<T>) {
  const hasData = Array.isArray(items) && items.length > 0;

  return (
    <SampleWidget title={title} loading={loading} hasData={hasData} onRefresh={onRefresh}>
      <ModuleListContainer>
        {hasData ? (
          (items as T[]).map((it, idx) => <div key={idx}>{renderItem(it, idx)}</div>)
        ) : (
          <div style={{ padding: 12 }}>{emptyLabel}</div>
        )}
      </ModuleListContainer>
    </SampleWidget>
  );
}

export default ModuleListWidget;
